import { render, staticRenderFns } from "./tournamentReports.vue?vue&type=template&id=7563c028&scoped=true"
import script from "./tournamentReports.vue?vue&type=script&lang=js"
export * from "./tournamentReports.vue?vue&type=script&lang=js"
import style0 from "./tournamentReports.vue?vue&type=style&index=0&id=7563c028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7563c028",
  null
  
)

export default component.exports